import styled from '@emotion/styled'
import { TOKENS } from '../../constants/tokens'

export const WrapperComponent = styled.section`
  width: 75%;
  @media (min-width: ${TOKENS.media.small}px) {
    width: 90%;
  }
  max-width: 1250px;
  margin-left: auto;
  margin-right: auto;
  height: 100%;
`